<template>
  <div class="calendar-content">
    <div class="calendar-row cal-labels-row" v-if="previewMode === calendarViewModes.MONTH">
      <div class="cal-cell1" v-for="(day, i) in data.weekDays" :key="i">
        {{day}}
      </div>
    </div>

    <div class="calendar-row" v-for="(row, i) in rows" :key="i">
      <div v-for="(item, index) in row" :key="index" class="calendar-item">
        <div class="day-wrapper" :class="{
          'month': previewMode === calendarViewModes.MONTH,
          'week': previewMode === calendarViewModes.WEEK,
          'current-day': isCurrentDay(item.date),
          'not-current-month': !isDateNotInCurrentMonth(item.date) && previewMode === calendarViewModes.MONTH
          }">
          <CalendarBox
            :item="item"
            :id="'' + i + index" :isExpanded="isExpanded"
            :previewMode='previewMode'
            @expand="expand"
            @collapse="collapse" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarBox from '@/components/common/calendar/CalendarBox'
import moment from 'moment'
import * as calendarService from '@/services/calendarService'
import _ from 'lodash'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'

export default {
  name: 'Calendar',
  props: [
    'account',
    'previewMode',
    'events',
    'viewDate',
    'onPeriodChange',
    'isExpanded',
    'onExpandedBoxChange'
  ],
  data () {
    return {
      year: 2018,
      month: 10,
      dates: [],
      startDate: null,
      endDate: null,
      calendarData: null,
      rows: null,
      calendarViewModes: CALENDAR_VIEW_MODES
    }
  },

  computed : {
    data() {
      return {
        weekDays: [
          this.$t('CALENDAR.weekDays.sunday'),
          this.$t('CALENDAR.weekDays.monday'), 
          this.$t('CALENDAR.weekDays.tuesday'), 
          this.$t('CALENDAR.weekDays.wednesday'), 
          this.$t('CALENDAR.weekDays.thursday'), 
          this.$t('CALENDAR.weekDays.friday'), 
          this.$t('CALENDAR.weekDays.saturday'), 
        ],
      }
    }
  },
  mounted () {
    this.setViewDate()
    this.generateStartEndDates()
    this.getDisplayDays()
  },
  methods: {
    setViewDate () {
      if (this.previewMode === CALENDAR_VIEW_MODES.MONTH) {
        this.startDate = moment(this.viewDate).startOf('month').toDate()
      } else {
        this.startDate = moment(this.viewDate).startOf('week').toDate()
      }
    },
    generateStartEndDates () {
      const { startDate, endDate } = calendarService.generateStartEndDates(this.startDate, this.previewMode)
      this.startDate = startDate
      this.endDate = endDate

      this.onPeriodChange({ startDate: this.startDate, endDate: this.endDate })
    },
    getDisplayDays () {
      const dates = calendarService.getArrayOfDays(this.startDate, this.endDate)
      const calendarData = []

      dates.forEach(date => {
        calendarData.push({
          date,
          events: this.events ? this.events.filter(o => o.started.getTime() === date.getTime()) : []
        })
      })
      this.rows = _.chunk(calendarData, 7)
      this.calendarData = calendarData
    },
    isDateNotInCurrentMonth (date) {
      return date.getMonth() === this.viewDate.getMonth()
    },
    isCurrentDay (date) {
      return date.getDate() === new Date().getDate() && date.getMonth() === new Date().getMonth() && date.getFullYear() === new Date().getFullYear()
    },
    expand (id) {
      this.onExpandedBoxChange(id)
    },
    collapse (id) {
      this.onExpandedBoxChange()
    }
  },
  watch: {
    previewMode: function (newValue, oldValue) {
      this.setViewDate()
      this.generateStartEndDates()
      this.getDisplayDays()
    },
    viewDate: function (newValue, oldValue) {
      this.setViewDate()
      this.generateStartEndDates()
      this.getDisplayDays()
    },
    events: function (newValue) {
      this.getDisplayDays()
    },
    account () {
      this.onPeriodChange({ startDate: this.startDate, endDate: this.endDate })
    }
  },
  components: {
    CalendarBox
  }
}
</script>

<style lang="scss">
  @import '@/scss/components/_calendar.scss';
</style>
